import ExpiringDelegationsModal from './expiring-delegations-modal-container'

export default ExpiringDelegationsModal
